import { motion } from "framer-motion";
import { useCart } from "../context/CartContext";
import toast from "react-hot-toast";

export default function ProductCard({ item, openModal }) {
  const { favourites, toggleFav, addToCart } = useCart();

  return (
 <motion.article
  layout
  whileHover={{ scale: 1.01 }}
  className="
    bg-white rounded-xl overflow-hidden shadow
    w-full 
    sm:max-w-sm 
    mx-auto
  "
>

      <div
        className="relative cursor-pointer"
        onClick={() => openModal(item)}
      >
<img 
  src={item.image} 
  alt={item.name} 
  className="w-full h-56 sm:h-56 md:h-64 object-cover"
/>


        {/* ❤️ FAV */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            toggleFav(item.id);
            favourites.includes(item.id)
              ? toast.error("Removed from favourites")
              : toast.success("Added to favourites ❤️");
          }}
          className="absolute top-3 right-3 bg-white/90 p-2 rounded-full"
        >
          {favourites.includes(item.id) ? "❤️" : "🤍"}
        </button>

        {/* DISCOUNT LABEL */}
        {item.discountPercent > 0 && (
          <div className="absolute top-3 left-3 bg-indigo-600 text-white text-xs px-2 py-1 rounded">
            -{item.discountPercent}%
          </div>
        )}

        {/* Bottom Overlay */}
<div className="absolute bottom-0 left-0 w-full 
  p-3 sm:p-4 
  bg-black/20 backdrop-blur-xxl text-white border-t border-white/10">


          <h3 className="text-base font-semibold line-clamp-1">
            {item.name}
          </h3>

          <div className="mt-1 flex items-baseline gap-2">
            <div className="text-xl font-bold">₹{item.discountedPrice}</div>
            <div className="text-gray-300 text-sm line-through">₹{item.price}</div>
          </div>

          <div className="mt-3 flex gap-3">
            <button
              onClick={(e) => {
                e.stopPropagation();
                openModal(item);
              }}
              className="flex-1 text-sm px-3 py-2 bg-indigo-600 rounded"
            >
              View
            </button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                addToCart(item);
                toast.success("Added to Cart 🛒");
              }}
              className="text-sm px-3 py-2 bg-white/90 text-black rounded"
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </motion.article>
  );
}
